module.exports = (__webpack_require__(14))(177);


//////////////////
// WEBPACK FOOTER
// delegated ./src/collections/ItemCollection.js from dll-reference girder_lib
// module id = 59
// module chunks = 0